"use client";

import Script from "next/script";
import React, { Suspense, useEffect } from "react";
import Loader from "@/components/core/Loader";
import Navbar from "@/components/headerNew/Navbar";
import dynamic from "next/dynamic";
import { motion } from "framer-motion";
import Hero from "@/components/homeNew/Hero";
const MobileApp = dynamic(() => import("@/components/homeNew/MobileApp"), {
  ssr: false,
  loading: () => <Loader />,
});
const Counter = dynamic(() => import("@/components/homeNew/Counter"), {
  ssr: false,
  loading: () => <Loader />,
});
const FeaturedParaa = dynamic(
  () => import("@/components/homeNew/FeaturedPraraa"),
  { ssr: false, loading: () => <Loader /> }
);
const Portfolio = dynamic(() => import("@/components/homeNew/Portfolio"), {
  ssr: false,
  loading: () => <Loader />,
});
const Solution = dynamic(() => import("@/components/homeNew/Solution"), {
  ssr: false,
  loading: () => <Loader />,
});
const Learn = dynamic(() => import("@/components/homeNew/LearnAboutPara"), {
  ssr: false,
  loading: () => <Loader />,
});
const GetApp = dynamic(() => import("@/components/homeNew/GetApp"), {
  ssr: false,
  loading: () => <Loader />,
});
const Footer = dynamic(() => import("@/components/newFooter/Footer"), {
  ssr: false,
  loading: () => <Loader />,
});
const Exxp = dynamic(() => import("@/components/homeNew/Experience1"), {
  ssr: false,
  loading: () => <Loader />,
});

const HomeContent = () => {
  useEffect(() => {
    document.title = "Paraacrypto | Learn Crypto Trading with Virtual Coins";

    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Paraacrypto helps you learn crypto trading safely using virtual coins. Practice risk-free and build your skills before investing real money."
      );
    } else {
      const newMeta = document.createElement("meta");
      newMeta.name = "description";
      newMeta.content =
        "Paraacrypto helps you learn crypto trading safely using virtual coins. Practice risk-free and build your skills before investing real money.";
      document.head.appendChild(newMeta);
    }
  }, []);

  return (
    <>
      <Suspense fallback={<Loader />}>
        <Script
          src="https://files.coinmarketcap.com/static/widget/coinMarquee.js"
          defer
        />
        <div className="items-center justify-center">
          <section className="w-full overflow-x-hidden">
            <div className="!sticky top-0 z-50 bg-white">
              <Navbar />
            </div>
            {/* LCP: Hero is not lazy loaded */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              <Hero />
            </motion.div>

            {/* Lazy loaded sections below Hero */}
            <motion.div
              initial={{ opacity: 0, y: 100 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 1, type: "spring", bounce: 0.3 }}
            >
              <MobileApp />
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 100 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 1, type: "spring", bounce: 0.3 }}
            >
              <Counter />
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 100 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 1, type: "spring", bounce: 0.3 }}
            >
              <FeaturedParaa />
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 100 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 1, type: "spring", bounce: 0.3 }}
            >
              <Portfolio />
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 100 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 1, type: "spring", bounce: 0.3 }}
            >
              <Solution />
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 100 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 1, type: "spring", bounce: 0.3 }}
            >
              <Exxp />
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 100 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 1, type: "spring", bounce: 0.3 }}
            >
              <Learn />
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 100 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 1, type: "spring", bounce: 0.3 }}
            >
              <GetApp />
            </motion.div>

            <Footer />
          </section>
        </div>
      </Suspense>
    </>
  );
};

export default HomeContent;
